import { useSettings } from '../../../../hooks/useSettings'
import i18n from '../../../../i18n/i18next'
import { languages } from '../../../../types/constants'

function ChangeLanguage() {
  const [language, saveLanguage] = useSettings('lang')

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
    saveLanguage(lng)
  }

  return (
    <ul className="langSel">
      {languages.map((lang, idx) => (
        <li key={idx}>
          {' '}
          <a onClick={() => changeLanguage(lang)} className={language === lang ? 'active' : 'inactive'}>
            {lang}
          </a>
        </li>
      ))}
    </ul>
  )
}

export default ChangeLanguage
